import {MathJax, MathJaxContext} from "better-react-mathjax";
import {isNullOrUndefined} from "../../../../services/Validator";
import ExerciserQuestionWarningText from "./ExerciserQuestionWarningText";

export default function Exerciser159QuestionText({question, warning}) {
    // Used through the app to display Exerciser question
    // text

    // BUILD
    if (isNullOrUndefined(question))
        return null
    return (
        <div className={"w-full max-w-[500px] mt-[16px]"}>
            <div className={"flex flex-col justify-start items-center text-center px-[16px] py-[12px] border-[1px] border-greyLight5 rounded-[16px]"}>
                <MathJaxContext>
                    <MathJax inline dynamic>
                        <span className="whitespace-pre-line font-medium text-[20px] text-white">
                            {question ?? "Erreur"}
                        </span>
                    </MathJax>
                </MathJaxContext>
                {!isNullOrUndefined(warning)
                    ? <ExerciserQuestionWarningText warning={warning} />
                    : null}
            </div>
        </div>
    );
}